import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiClock, FiPercent } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';

const DiscountTimer = () => {
  const [timeLeft, setTimeLeft] = useState(24 * 60 * 60); // 24 hours in seconds
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div 
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        exit={{ y: 100 }}
        className="fixed bottom-0 left-0 w-full bg-gradient-to-r from-mx-red via-mx-green to-mx-red z-40 text-white shadow-[0_-5px_20px_rgba(0,0,0,0.3)]"
      >
        <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col md:flex-row items-center justify-between gap-2">
          <div className="flex items-center gap-3">
            <div className="bg-white/20 p-2 rounded-full animate-pulse">
              <FiPercent className="text-xl text-yellow-300" />
            </div>
            <div>
              <div className="font-black uppercase tracking-wide text-sm md:text-base">
                Flash Sale: 20% OFF First Visit
              </div>
              <div className="text-xs opacity-90 italic">
                Oferta Relámpago: 20% Descuento Primera Visita
              </div>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <div className="font-mono font-bold text-xl md:text-2xl bg-black/30 px-4 py-1 rounded-lg border border-white/20 flex items-center gap-2">
              <FiClock className="text-yellow-300" />
              {formatTime(timeLeft)}
            </div>
            
            <a 
              href="https://wa.me/529841771113?text=I want the 20% Discount Code: MEXICO20"
              target="_blank"
              rel="noreferrer"
              className="bg-white text-mx-red px-6 py-2 rounded-full font-bold text-xs md:text-sm uppercase hover:bg-yellow-300 hover:text-black transition-colors shadow-lg flex items-center gap-2 whitespace-nowrap"
            >
              <FaWhatsapp /> Claim Offer / Reclamar
            </a>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default DiscountTimer;